import http from './http'

const requisicaoService = {
  getAll: page => http.get(`/requisicao?page=${page}`).then(result => result.data),
  getAllR: page => http.get(`/requisicaor?page=${page}`).then(result => result.data),
  getByBaixa: page => http.get(`/requisicaobaixa?page=${page}`).then(result => result.data),
  getById: id => http.get(`/requisicao/${id}`).then(result => result.data),
  getByGetBaixa: id => http.get(`/requisicaogetbaixa/${id}`).then(result => result.data),
  getByNome: (str, page) => http.get(`/requisicaobynome/${str}?page=${page}`).then(result => result.data),
  getByTodos: (empresa, fornecedor) => http.get(`/requisicaotodos/${empresa}/${fornecedor}`).then(result => result.data),
  getByEmpresas: empresa => http.get(`/requisicaoempresas/${empresa}`).then(result => result.data),
  getByEmpresasHabilitadas: () => http.get(`/requisicaoempresashabilitadas`).then(result => result.data),
  getAllCliente: page => http.get(`/requisicaocliente?page=${page}`).then(result => result.data),
  getByVeiculo: (str, page) => http.get(`/requisicaogetveiculo/${str}?page=${page}`).then(result => result.data),
  getRequisicaoTudo: () => http.get(`/requisicaotudo`).then(result => result.data),
  save: data => http({
    method: 'post',
    url: `/requisicao`,
    data
  }),
  savePostBaixa: data => http({
    method: 'post',
    url: `/requisicaopostbaixa`,
    data
  }),
  savePut: data => http({
    method: 'put',
    url: `/requisicao/${data.id}`,
    data
  }).then(result => result.data.data),
  savePutSet: data => http({
    method: 'put',
    url: `/requisicaoset/${data.id}`,
    data
  }).then(result => result.data.data),
  saveAltera: data => http({
    method: 'put',
    url: `/requisicaoaltera/${data.id}`,
    data
  }).then(result => result.data.data),
  saveCancelar: data => http({
    method: 'put',
    url: `/requisicaocancelar/${data.id}`,
    data
  }).then(result => result.data.data),
  delete: id => http.delete(`/requisicao/${id}`)
}
export default requisicaoService
